import type { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth';
import { profileGuard } from '@core/guards/profile';
import { publicGuard } from '@core/guards/public';

export const routes: Routes = [
  {
    path: 'auth/sign-in',
    canActivate: [publicGuard],
    loadComponent: () => import('./auth/sign-in/sign-in'),
  },
  {
    path: '',
    loadComponent: () => import('./components/layout/authenticated-layout'),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard'),
      },
      {
        path: 'gestion',
        data: { roleId: [1] },
        canActivate: [profileGuard],
        children: [
          {
            path: 'mantenimientos',
            loadChildren: () => import('./management/management.route'),
            canActivate: [profileGuard],
            data: { roleId: [10] },
          },
          {
            path: 'procesos',
            canActivate: [profileGuard],
            loadChildren: () => import('./processes/processes.route'),
            data: { roleId: [20] },
          },
          {
            path: '**',
            redirectTo: 'mantenimientos',
          },
        ],
      },
      {
        path: 'operaciones',
        data: { roleId: [2] },
        canActivate: [profileGuard],
        children: [
          {
            path: 'despachos',
            canActivate: [profileGuard],
            loadChildren: () => import('./shipments/features/shipments.routes'),
            data: { roleId: [30] },
          },
          {
            path: 'consultas',
            canActivate: [profileGuard],
            loadChildren: () => import('./queries/features/queries.routes'),
            data: { roleId: [40] },
          },
          {
            path: '**',
            redirectTo: 'despachos',
          },
        ],
      },
      {
        path: '**',
        redirectTo: 'dashboard',
      },
    ],
  },
];
